import { MatDialogConfig } from '@angular/material/dialog';

import { DialogData, IIdentity } from '.';

export interface DialogCellConfig<T extends IIdentity>
  extends MatDialogConfig<DialogData<T>> {
  additionalData?: any;
  beforeOpenAdaptor?: (data: Partial<T>, additionalData?: any) => void;
  afterCloseAdaptor?: (data: Partial<T>, additionalData?: any) => void;
}
